export var Animations;
(function (Animations) {
    Animations["CATEGORIES_DEFAULT"] = "Categories_Default";
    Animations["ENGAGEMENT_SECURITY"] = "Engagement_Security";
    Animations["ENGAGEMENT_AT_YOUR_SERVICE"] = "Engagement_At_Your_Service";
    Animations["MEAL_COFFEE"] = "Meal_Coffee";
    Animations["NEW_CARD_AVAILABLE"] = "New_Card_Available";
    Animations["OTHER_GIFT"] = "Other_Gift";
    Animations["OTHER_LOADING"] = "Other_Loading";
    Animations["OTHER_PHONE"] = "Other_Phone";
    Animations["OTHER_TRAVELER"] = "Other_Traveler";
    Animations["PAYMENT_LOCKED_CHECKED"] = "Payment_Locked_Checked";
    Animations["PAYMENT_LOCKED_ERROR"] = "Payment_Locked_Error";
    Animations["PAYMENT_NEW_CARD"] = "Payment_New_Card";
    Animations["PAYMENT_NFC_CHECKED"] = "Payment_Nfc_Checked";
    Animations["PAYMENT_NFC_ERROR"] = "Payment_Nfc_Error";
    Animations["PAYMENT_SECURITY_CHECKED"] = "Payment_Security_Checked";
    Animations["PRODUCT_CARD1"] = "Product_Card1";
    Animations["PRODUCT_GIFTPHONE"] = "Product_GiftPhone";
    Animations["STATUS_APPLEID_CHECKED"] = "Status_AppleID_Checked";
    Animations["STATUS_APPLEID_ERROR"] = "Status_AppleID_Error";
    Animations["STATUS_QRCODE_CHECKED"] = "Status_Qrcode_Checked";
    Animations["STATUS_QRCODE_ERROR"] = "Status_Qrcode_Error";
    Animations["STATUS_SECURITY_CHECKED"] = "Status_Security_Checked";
    Animations["STATUS_SECURITY_LOADING"] = "Status_Security_Loading";
    Animations["STATUS_SECURITY_WARNING"] = "Status_Security_Warning";
    Animations["STATUS_WIFI_CHECKED"] = "Status_Wifi_Checked";
    Animations["STATUS_WIFI_ERROR"] = "Status_Wifi_Error";
})(Animations || (Animations = {}));
//# sourceMappingURL=animations.types.js.map